// actions.js
import { constants } from "../constants/redux-constants";

export const showLoader = () => ({
  type: constants.SHOW_LOADER,
});

export const hideLoader = () => ({
  type: constants.HIDE_LOADER,
});

export const progressStatus = (payload) => ({
  type: constants.PROGRESS_STATUS,
  payload,
});
export const set_encounter_loading = (payload) => ({
  type: constants?.SET_ENC_LOADING,
  payload,
});
export const set_template_loading = (payload) => ({
  type: constants?.SET_TEMPLATE_LOADING,
  payload,
});
